import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import loading from './modules/loading'
import project from './modules/project'
import permission from './modules/permission'
import google from './modules/google'
import auth from './modules/auth'
import category from './modules/category'
import invitation from './modules/invitation'
import codelab from './modules/codelab'
import success from './modules/success'

export default new Vuex.Store({
    modules: {
        loading,
        project,
        permission,
        google,
        auth,
        category,
        invitation,
        codelab,
        success,
    },
})
